import randomString from 'random-string';
import { encryptAESRSA } from '@rambler-id/crypto';
import { decamelizeRpcKeys } from './keys';
export const getEncryptionData = (params, encryptionFields) => encryptionFields.reduce((acc, field) => {
    if (field in params) {
        return {
            ...acc,
            [field]: params[field]
        };
    }
    return acc;
}, {});
export const encryptData = async (params, encryptionKey, encryptionFields, getServerTime) => {
    const encryptionData = getEncryptionData(params, encryptionFields);
    if (Object.keys(encryptionData).length) {
        try {
            const { time } = await getServerTime();
            encryptionData.ctime = time;
            encryptionData.nonce = randomString();
            const encryptedData = await encryptAESRSA(encryptionKey, JSON.stringify(decamelizeRpcKeys(encryptionData)));
            return {
                encryptedData,
                encrypted: 1
            };
        }
        catch { }
    }
    return {};
};
